import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthTarget } from '../../models/auth-target.model';

import { AuthService } from '../../services/auth.service';

interface AuthParams {
  authSessionId?: string;
}

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: false
})
export class AuthComponent implements OnInit, OnDestroy {
  private paramsSub: Subscription = Subscription.EMPTY;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.paramsSub = forkJoin([this.route.queryParams.pipe(take(1)), this.route.data.pipe(take(1))]).subscribe(
      ([params, routeData]: [AuthParams, { target: AuthTarget }]) => {
        console.log('Auth Params: ', params);
        if (params.authSessionId) {
          this.authService.loginUser(params.authSessionId, routeData.target);
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.paramsSub.unsubscribe();
  }
}
